var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_3403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H22C22.5523 4 23 4.44772 23 5V8.02148C20.9903 8.23325 19.4238 9.93398 19.4238 12C19.4238 14.066 20.9903 15.7657 23 15.9775V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V15.9775C3.00971 15.7657 4.57617 14.066 4.57617 12C4.57617 9.93398 3.00976 8.23323 1 8.02148V5C1 4.44772 1.44772 4 2 4Z",
    fill: "white",
    stroke: "#2A2E34",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_3403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4H23V20H14V4Z",
    fill: "#B9CCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4V20H14V4H16Z",
    fill: "#2A2E34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19V21H2V19H22ZM24 8.47461C24 8.77509 23.7243 9 23.4238 9C21.7671 9.00016 20.4238 10.3432 20.4238 12C20.4238 13.6568 21.7671 14.9998 23.4238 15C23.7243 15 24 15.2239 24 15.5244V19L23.9893 19.2041C23.8938 20.1457 23.1457 20.8938 22.2041 20.9893L22 21V16.793C19.9326 16.1796 18.4238 14.2667 18.4238 12C18.4238 9.73321 19.9324 7.8193 22 7.20605V5H2V7.20605C4.06758 7.81929 5.57617 9.73322 5.57617 12C5.57617 14.2667 4.06744 16.1796 2 16.793V21L1.7959 20.9893C0.787223 20.887 0 20.0357 0 19V15.5244C0 15.2239 0.275655 15 0.576172 15C2.23291 14.9999 3.57617 13.6568 3.57617 12C3.57617 10.3432 2.23291 9.00013 0.576172 9C0.275697 9 0 8.77508 0 8.47461V5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V8.47461Z",
    fill: "#2A2E34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.e32ec928ea6b95761e12ba4de69975f5.svg";
export { ForwardRef as ReactComponent };